module.exports = {
    prefix: 'lodging',
    extPrefix: 'supply/lodging',
};
